/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {Function} from './function';

export class Service extends BaseEntity {
  type: string;
  functions: Function[];
}
